export default function initCopyCode() {
    const codeBlocks = document.querySelectorAll(".gh-content pre code");

    if (!codeBlocks.length) {
        return;
    }

    codeBlocks.forEach((codeBlock) => {
        const pre = codeBlock.closest("pre");

        if (!pre || pre.dataset.copyReady === "true") {
            return;
        }

        pre.dataset.copyReady = "true";
        pre.classList.add("gh-code-block");

        const button = document.createElement("button");
        button.type = "button";
        button.className = "gh-copy-code-button";
        button.textContent = "Copy";
        button.setAttribute("aria-label", "Copy code to clipboard");

        button.addEventListener("click", async () => {
            const codeText = codeBlock.innerText;

            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(codeText);
                } else {
                    const textarea = document.createElement("textarea");
                    textarea.value = codeText;
                    textarea.setAttribute("readonly", "");
                    textarea.style.position = "fixed";
                    textarea.style.opacity = "0";
                    document.body.appendChild(textarea);
                    textarea.focus();
                    textarea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textarea);
                }

                button.textContent = "Copied!";
                button.classList.add("copied");
            } catch (error) {
                button.textContent = "Failed";
                button.classList.add("copied");
            }

            window.setTimeout(() => {
                button.textContent = "Copy";
                button.classList.remove("copied");
            }, 1800);
        });

        pre.appendChild(button);
    });
}
